<template>
  <div class="random-interview relative bg-white" style="height: calc(100vh - 83px)">
    <!-- 下面的表格 -->
    <div class="basic-content bg-white relative" style="height: calc(100vh - 83px);overflow:auto">
      <!-- 选中的调查员表格 -->
      <selected-interviewer
        class=""
        v-if="activeIndex === '1'"
        :importBool="importBool"
        @importTable="importTable"
        :inputPlaceholder="inputPlaceholderOptions"
        :taskStatus="taskStatusOptions"
        :tableColumnName="tableColumnNameOptions"
        :propTableData="tableData"
        :combineField="combineFieldOptions"
        @inputValueChange="getTableData"
        :switchChangeFunc="putOfflineTaskSwitch"
        :parseParamsFunc="parseParams"
        :successFunc="successHandler"
        :newField="newFieldOptions"
        :addArrangeParams="addArrangeParamsHandler"
        :createTaskFunc="plCreat"
        channel="randomInterviewer"
        :total="total"
        :searchRight="true"
        @flag="getflag"
        @setTask="getLoadData"
        @welcomeAddInterviewer="() => (this.addInterviewer())"
        :propsWelcomeShow="propsWelcomeShow"
        >
        <template slot="selected-left">
          <div class="z-10 inline-block" style="width: 310px;" v-show="flag">
            <el-button type="primary" @click="addInterviewer">添加调查员</el-button>
            <el-button @click="recuitment">去任务广场招募</el-button>
          </div>
        </template>
      </selected-interviewer>
      
     
      <!-- 报名的调查员表格 -->
      <signup-interviewer v-else-if="activeIndex === '2'" @handlerSum="handlerSumHandler" />
    </div>

    <el-drawer
      title="添加调查员"
      :visible.sync="addDrawer"
      direction="rtl"
      size="80%"
      :destroy-on-close="true"
      :before-close="handleAddDrawerClose"
    >
      <div class="main-box w-full box-border">
        <AddInterviewer @close="handleAddDrawerClose" @emitDialog="changeOverDialog"></AddInterviewer>
      </div>
    </el-drawer>
    <el-drawer
      title="任务广场招募调查员"
      :visible.sync="recruitDrawer"
      size="70%"
      :destroy-on-close="true"
      :before-close="handleRecruitDrawerClose"
    >
      <RecruitmentForm
        @cancel="handleRecruitDrawerClose"
        :surveyId="GlobalConfig.getSurveyId()"
        :pageType="'visitor'"
      ></RecruitmentForm>
    </el-drawer>
    <el-drawer
      title="任务广场招募说明"
      :visible.sync="taksSquareDrawerVisible"
      :size="810"
      :destroy-on-close="true"
      :before-close="handleTaksSquareDrawerClose"
    >
      <div class="taks-drawer-wrap">
        <div class="taks-drawer-title">任务广场招募说明</div>
        <p>点击前往<a href="https://task.survey.work/" target="_blank">任务广场</a></p>
        <div class="bit-img">
          <!-- <img src="../../../assets/img/wj/taksSquare.png" alt="" /> -->
          <el-image 
            style="width: 100%"
            :src="url" 
            :preview-src-list="srcList"
            >
        </el-image>
        </div>
      </div>
      <div class="taks-drawer-footer">
        <el-button @click="handleTaksSquareDrawerClose" type="primary">我知道了</el-button>
      </div>
    </el-drawer>
    <over-mask
      :dialogVisible="dialogVisible"
      @handleClose="
        () => {
          dialogVisible = false
        }
      "
    ></over-mask>
    <DialogVersion :visible="dialogVersionVisible" type="random" @close="()=> dialogVersionVisible=false" />
  </div>
</template>

<script>
import selectedInterviewer from './components/SelectedInterviewer.vue'
import signupInterviewer from './components/SignupInterviewer.vue'
import AddInterviewer from './components/AddInterviewer.vue'
import RecruitmentForm from './components/RecruitmentForm.vue'
import { getRecruitTaskList, getRandomInterviewTableData, putOfflineTask, putOfflineTaskSwitch, jobExecutionExcel } from '@/api/wenjuan/offline.js'
import {
  inputPlaceholderOptions,
  taskStatusOptions,
  tableColumnNameOptions,
  dialogData,
  newFieldOptions
} from './options/index.js'
import { plCreat } from '@/api/wenjuan/addList.js'
import GlobalConfig,{ AuthConfig } from '@/global/config'
import OverMask from '@/views/survey/offline/components/overMask/OverMask.vue'
import { toTaskSquare } from '@/assets/js/base-platform.js'
import taksSquareImg from '../../../assets/img/wj/taksSquare.png'
import DialogVersion from '@/views/survey/offline/components/dialog/DialogVersion.vue'

export default {
  name: 'random-interview',
  components: {
    selectedInterviewer,
    signupInterviewer,
    AddInterviewer,
    RecruitmentForm,
    OverMask,
    DialogVersion
  },
  data() {
    return {
      dialogVersionVisible:false,
      importBool: 'import',
      taksSquareDrawerVisible: false, // 任务广场弹窗控制显示隐藏
      GlobalConfig,
      addDrawer: false,
      recruitDrawer: false,
      activeIndex: '1',
      handlerSum: '',
      guideDialog: false,
      dialogData: [],
      // 输入框提示语 提供给共通组件配置
      inputPlaceholderOptions: {},
      // 可选的任务状态配置
      taskStatusOptions: [],
      // 表格列名配置
      tableColumnNameOptions: {},

      tableData: [], // 获取到的 table 的数据
      // 按照什么字段合并
      combineFieldOptions: {
        name: 'executorName',
        concat: 'executorPhone',
        id: 'id'
      },
      putOfflineTaskSwitch: new Function(),
      newFieldOptions: {},
      plCreat: new Function(),
      total: 0,
      isShowGuide: false,
      dialogVisible: false,
      flag: true,
      // 调查员id
      investigatorId: 0,
      url:'/assets/img/settlement/taks-square.png',
      srcList: ['/assets/img/settlement/taks-square.png'],
      propsWelcomeShow: false,
    }
  },
  methods: {
    importTable() {
      let obj = {
        surveyId: GlobalConfig.getSurveyId()
      }
      jobExecutionExcel(obj)
        .then(res => {
          let url = res.data.data
          if (url) {
            window.open(url)
          } else {
            this.$message.error('导出失败')
          }
        })
        .catch(err => {
          this.$message.error('导出失败')
        })
    },
    getflag(v) {
      this.flag = v
    },
    handleSelect(index) {
      // string: 1 / 2
      index == 1 && this.getTableData()
      this.activeIndex = index
    },
    addInterviewer() {
      // this.addDrawer = true
      // if(![AuthConfig.TeamBase, AuthConfig.TeamPlus].includes(GlobalConfig.getAuthCode())){
      //   this.dialogVersionVisible = true
      // }else{
      //   this.addDrawer = true
      // }
        // const phone = this.$store.state.base?.userInfo?.phone;
      // if([AuthConfig.PersonalPlus].includes(GlobalConfig.getAuthCode())){
      //   if(this.tableData?.length < 1){
      //     this.addDrawer = true
      //   }else{
      //     this.$message.warning('当前版本暂时只能创建一条数据');
      //   }
      // }else if([AuthConfig.Personal].includes(GlobalConfig.getAuthCode()) && phone === '17859061055'){
      //   if(this.tableData?.length < 1){
      //     this.addDrawer = true
      //   }else{
      //     this.$message.warning('当前版本暂时只能创建一条数据');
      //   }
      // }else 
      if([AuthConfig.TeamBase, AuthConfig.TeamPlus].includes(GlobalConfig.getAuthCode())){
        this.addDrawer = true
      }else{
        this.dialogVersionVisible = true
      }
    },
    handleAddDrawerClose() {
      this.init()
      this.getTableData().then(()=> {
        this.propsWelcomeShow = this.total === 0
      })
      this.addDrawer = false
    },
    recuitment() {
      // toTaskSquare();
      this.taksSquareDrawerVisible = true
      // this.recruitDrawer = true
      //this.$router.push(`/survey/${GlobalConfig.getSurveyId()}/offline/random-interview/recruit`)
    },
    handleRecruitDrawerClose() {
      this.recruitDrawer = false
    },
    // 关闭任务广场弹窗
    handleTaksSquareDrawerClose() {
      this.taksSquareDrawerVisible = false
    },

    // 【未处理数】的处理函数
    handlerSumHandler(handlerSum) {
      // console.log('handlerSum: ', handlerSum);
      this.handlerSum = handlerSum
    },

    // 获取表格数据的方法 如果传入了 params，就用传入的 没传入就用 defaultParams
    getTableData(temParams) {
      let defaultParams = {
        surveyId: GlobalConfig.getSurveyId(),
        id: this.investigatorId !== 0 ? this.investigatorId : null,
        current: 1,
        size: 20
      }
      let params = Object.assign({}, defaultParams)
      if (temParams) {
        temParams.commonName && (params.executorName = temParams.commonName)
        temParams.commonPhone && (params.executorPhone = temParams.commonPhone)
        temParams.commonTaskName && (params.executionName = temParams.commonTaskName)
        temParams.taskStatusValue && (params.status = temParams.taskStatusValue)
        params.current = temParams.current
      }
      return getRandomInterviewTableData(params)
        .then(res => {
          // this.guideDialog = res.data.data.records.length == 0 ? true : false;
          this.isShowGuide = res.data.data.records.length == 0 ? true : false
          // this.tableData = res.data.data.records;
          this.total = res.data.data.total

          // 处理数据
          // 在每条数据上加上 show 和 edit 字段 之后表格操作会用到
          this.tableData = res.data.data.records.map(item => {
            // 模拟数据

            // item.settleMode = 1;
            // item.settleRule ={
            //   "tiers": [
            //     {
            //       "unitPriceYuan": 10,
            //       "quantityLowerBound": 1,
            //       "quantityUpperBound": 100
            //     },
            //     {
            //       "unitPriceYuan": 20,
            //       "quantityLowerBound": 101,
            //       "quantityUpperBound": 200
            //     },
            //     {
            //       "unitPriceYuan": 30,
            //       "quantityLowerBound": 201,
            //       "quantityUpperBound": 300
            //     }
            //   ],
            //   "unitPriceYuan": 1,
            //   "expectedQuantity": 1
            //   }

            // 新增的两个字段
            item.show = false
            item.edit = true

            // 修改字段 变成组件统一的 prop
            item.equalName = item.executorName
            item.equalPhone = item.executorPhone
            item.equalTaskName = item.executionName
            item.equalState = item.status
            item.equalTaskEndTime = item.executionValidateTo
            item.equalCount = item.executionQuantity
            item.equalPrice = item.executionSingleAmount
            item.equalCommitCount = item.recycledQuantity
            item.equalEffectiveCount = item.effectiveQuantity

            if (item.status == 7 || item.status == 8) {
              item.isOpen = false
            } else {
              item.isOpen = true
            }
            return item
          })
        })
        .catch(e => {
          this.$message.error('获取数据失败')
          console.log(e.message)
        })
    },

    parseParams(row, batchFlag) {
      batchFlag = batchFlag ? 1 : 0
      return { idList: [row.id], batchFlag, explanation: '' }
    },

    successHandler(row) {
      let status = row.isOpen ? 6 : 7
      row.status = status
    },
    // 新增项的参数处理
    addArrangeParamsHandler(data) {
      return [
        {
          surveyId: GlobalConfig.getSurveyId(),
          executorName: data.equalName,
          executorPhone: data.equalPhone,
          userName: data.equalName,

          executionName: data.equalTaskName,
          executionValidateTo: data.equalTaskEndTime,
          executionQuantity: data.equalCount,
          executionSingleAmount: data.equalPrice,
          recycledQuantity: '',
          effectiveQuantity: '',
          executionDescription: ''
        }
      ]
    },
    // 从配置文件中初始化一些东西
    init() {
      // 将在配置文件中导入的东西进行初始化
      this.inputPlaceholderOptions = inputPlaceholderOptions
      this.taskStatusOptions = taskStatusOptions
      this.tableColumnNameOptions = tableColumnNameOptions
      this.dialogData = dialogData
      this.newFieldOptions = newFieldOptions
    },
    // 从配置文件中初始化一些东西
    // init() {
    //   // 将在配置文件中导入的东西进行初始化
    //   this.inputPlaceholderOptions = inputPlaceholderOptions;
    //   this.taskStatusOptions = taskStatusOptions;
    //   this.tableColumnNameOptions = tableColumnNameOptions;
    //   this.dialogData = dialogData;
    //   this.putOfflineTask = putOfflineTask;
    //   this.newFieldOptions = newFieldOptions;
    //   this.plCreat = plCreat;
    // }
    getLoadData(val) {
      console.log('getLoadData', val)
    },
    changeOverDialog(val) {
      this.dialogVisible = val
    }
  },
  async created() {
    if (this.$route.query.id) {
      this.investigatorId = Number(this.$route.query.id)
    }

    this.init()
    this.getTableData().then(()=> {
      this.propsWelcomeShow = this.total === 0
    })
    let res = await getRecruitTaskList({
      surveyId: GlobalConfig.getSurveyId()
    })
    let count = 0
    res.data.data &&
      res.data.data.forEach(item => {
        item.interviewerList.forEach(n => {
          if (n.shopHasProxyJobStatus == 100) {
            count++
          }
        })
      })
    this.handlerSum = count == 0 ? '' : count
    // this.handlerSum = count;
    this.putOfflineTaskSwitch = putOfflineTaskSwitch
    this.plCreat = plCreat
    //this.init()
    this.guideDialog = this.isShowGuide
  }
}
</script>

<style lang="scss" scoped>
.random-interview {
  .banner {
    img {
      width: 100%;
      height: 100%;
    }
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    @apply text-theme;
  }
  ::v-deep .el-badge__content.is-fixed {
    position: absolute;
    top: 4px;
    right: 2px;
  }
  ::v-deep .el-badge__content {
    height: 18px;
    line-height: 16px;
  }
  .el-menu--horizontal {
    height: 46px;
    .el-menu-item {
      height: 46px;
    }
    .el-badge {
      line-height: 29px;
      height: 46px;
    }
  }
  .absolute {
    left: 0;
    position: absolute;
    top: 8px;
    width: 300px;
  }
  .basic-content {
    ::v-deep .el-card__body {
      min-height: calc(100vh - 350px) !important;
    }
    overflow: hidden;
  }

  .promptDialog {
    width: 100%;
    height: 70vh;
    h1 {
      text-align: center;
      color: #000;
      margin: 0;
    }
    .content {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .items {
        width: 25%;
        height: 120px;
        box-shadow: 0px 0px 5px 2px #eee;
        margin: 20px 2.1%;
        padding: 2%;
        border-radius: 5px;
        h3 {
          color: #000;
          font-size: 18px;
        }
        p {
          color: rgb(141, 141, 141);
          font-size: 16px;
          margin-top: 10px;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.taks-drawer-wrap {
  box-sizing: border-box;
  height: calc(100vh - 114px);
  overflow: auto;
  padding: 19px 48px;
  font-family: PingFangSC-Regular;
  text-align: center;
  line-height: 26px;
  .taks-drawer-title {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
  }
  & > p {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    margin-bottom: 30px;
    a {
      cursor: pointer;
      @apply text-theme;
    }
  }
  .bit-img img {
    width: 100%;
    height: auto;
    display: block;
  }
}
.taks-drawer-footer {
  width: 100%;
  height: 64px;
  padding: 0 24px;
  justify-content: end;
  align-items: center;
  display: flex;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
